// Shared mutable store for the active impersonation ID.
// The Axios interceptor reads this; UserContext writes it.
const state = { userId: null };

export function getImpersonateId() { return state.userId; }
export function setImpersonateId(id) { state.userId = id; }
